import React from 'react';
import './functions.css';
import Heading from '../../../../Miscs/Heading/Heading';

const Functions = () => {
	return (
		<>
			<div className="functions">
				<Heading>Functions</Heading>
			</div>
		</>
	);
};

export default Functions;
